export default "__VITE_ASSET__B2438O55__"